<!-- ========== Left Sidebar Start ========== -->

<div class="vertical-menu">

  <!-- LOGO -->
  <div class="navbar-brand-box" *ngIf="!validarImagenClienteTecsa">
    <a [routerLink]="['/']" class="logo logo-dark">
      <span class="logo-sm">
        <img src="assets/images/tecsa.png" alt="" height="30">
      </span>
      <span class="logo-lg">
        <img src="assets/images/tecsa-dark.png" alt="" height="30">
      </span>
    </a>

    <a [routerLink]="['/']" class="logo logo-light">
      <span class="logo-sm">
        <img src="assets/images/logoKonnectaWhiteSmall.png" alt="" height="30">
      </span>
      <span class="logo-lg">
        <img src="assets/images/logoKonnectaWhite.png" alt="" height="30">
      </span>
    </a>
  </div>
  <div class="navbar-brand-box" *ngIf="validarImagenClienteTecsa">
    <a [routerLink]="['/']" class="logo logo-dark">
      <span class="logo-sm">
        <img src="assets/images/logoKonnectaWhite.png" alt="" height="30">
      </span>
      <span class="logo-lg">
        <img src="assets/images/tecsa-dark.png" alt="" height="30">
      </span>
    </a>

    <a [routerLink]="['/']" class="logo logo-light">
      <span class="logo-sm">
        <img src="assets/images/logoKonnectaWhiteSmall.png" alt="" height="30">
      </span>
      <span class="logo-lg">
        <img src="assets/images/logoKonnectaWhite.png" alt="" height="30">
      </span>
    </a>
  </div>
  <button type="button" class="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn" (click)="toggleMobileMenu($event)">
    <i class="fa fa-fw fa-bars"></i>
  </button>
  @if(isCondensed){
  <ngx-simplebar class="sidebar-menu-scroll" #componentRef>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </ngx-simplebar>}@else{
  <ngx-simplebar class="sidebar-menu-scroll" #componentRef>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </ngx-simplebar>}

</div>

<ng-template #contentTemplate>

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
      @for (item of menuItems; track $index) {
      <ng-container *ngIf="!item.permiso || hasPermission(item.permiso)">
        @if(item.isTitle){
        <li class="menu-title">{{ item.label | translate}}</li>}
        <!-- Layouts menu -->
        @if (item.isLayout) {
        <li>
          <a href="javascript: void(0);" class="has-arrow">
            <i class="uil-window-section"></i>
            <span>{{'MENUITEMS.LAYOUTS.TEXT' | translate}}</span>
          </a>
          <ul class="sub-menu" aria-expanded="false">
            <li><a (click)="changeLayout('horizontal')" href="javascript: void(0);"> {{
                'MENUITEMS.LAYOUTS.LIST.HORIZONTAL' | translate}} </a></li>
            <li><a (click)="darkSidebar()" href="javascript: void(0);">{{ 'MENUITEMS.LAYOUTS.LIST.DARKSIDEBAR' |
                translate }} </a></li>
            <li><a (click)="compactSidebar()" href="javascript: void(0);">{{ 'MENUITEMS.LAYOUTS.LIST.COMPACTSIDEBAR' |
                translate}} </a></li>
            <li><a (click)="iconSidebar()" href="javascript: void(0);">{{ 'MENUITEMS.LAYOUTS.LIST.ICONSIDEBAR' |
                translate }} </a></li>
            <li><a (click)="boxedLayout()" href="javascript: void(0);">{{ 'MENUITEMS.LAYOUTS.LIST.BOXEDWITH' | translate
                }} </a></li>
            <li><a (click)="coloredSidebar()" href="javascript: void(0);">{{ 'MENUITEMS.LAYOUTS.LIST.COLOREDSIDEBAR' |
                translate}} </a></li>
          </ul>
        </li>
        }
        <!-- end Layout menu -->
        @if(!item.isTitle && !item.isLayout){
          <li *ngIf="!item.isTitle && !item.isLayout && hasItems(item)">
            <ng-container *ngIf="hasItems(item)">
              <a href="javascript:void(0);" class="is-parent" [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}">
                <i *ngIf="item.icon" class="bx {{ item.icon }}"></i>
                <span>{{ item.label | translate }}</span>
                <span *ngIf="item.badge" class="badge rounded-pill bg-{{item.badge.variant}} float-end">{{item.badge.text | translate}}</span>
              </a>
              <ul class="sub-menu" aria-expanded="false">
                <ng-container *ngFor="let subitem of item.subItems">
                  <li *ngIf="!subitem.subItems || !hasItems(subitem)">
                    <ng-container *ngIf="!subitem.permiso || hasPermission(subitem.permiso)">
                      <a [routerLink]="subitem.link" class="side-nav-link-ref" routerLinkActive="active-link">
                        {{ subitem.label | translate }}
                        <span *ngIf="subitem.badge" class="badge rounded-pill bg-{{subitem.badge.variant}} float-end">{{ subitem.badge.text | translate }}</span>
                      </a>
                    </ng-container>
                  </li>
                  <li *ngIf="subitem.subItems && hasItems(subitem)">
                    <a href="javascript:void(0);" class="has-arrow">{{ subitem.label | translate }}</a>
                    <ul class="sub-menu mm-collapse" aria-expanded="false">
                      <ng-container *ngFor="let subSubitem of subitem.subItems">
                        <ng-container *ngIf="!subSubitem.permiso || hasPermission(subSubitem.permiso)">
                          <li>
                            <a [routerLink]="subSubitem.link" class="side-nav-link-ref"
                            routerLinkActive="active-link" style="margin-left: -8px;">
                              {{ subSubitem.label | translate }}
                              <span *ngIf="subSubitem.badge" class="badge rounded-pill bg-{{subSubitem.badge.variant}} float-end">{{ subSubitem.badge.text | translate }}</span>
                            </a>
                          </li>
                        </ng-container>
                      </ng-container>
                    </ul>
                  </li>
                </ng-container>
              </ul>
            </ng-container>
          </li>
          <li *ngIf="!item.isTitle && !item.isLayout && !hasItems(item) && (!item.permiso || hasPermission(item.permiso))">
            <a [routerLink]="item.link" class="side-nav-link-ref"  [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active-link">
              <i *ngIf="item.icon" class="bx {{ item.icon }}"></i>
              <span>{{ item.label | translate }}</span>
              <span *ngIf="item.badge" class="badge rounded-pill bg-{{item.badge.variant}} float-end">{{item.badge.text | translate}}</span>
            </a>
          </li>
      }
      </ng-container>
      }
    </ul>
  </div>
</ng-template>
<!-- Sidebar -->

<!-- Left Sidebar End -->